import React from 'react';

// Page header for the v1.1 pages kept inside the v2 shell (Talent, Content):
// the v2 convention is a small crumb above a 22px title (design/v2 REVIEW 5.12).
const BreadCrumb = ({title, pageTitle, hidden = false}) => {
    if (hidden) return null;
    return (
        <div className="hz-page-head">
            <div>
                {pageTitle && <div className="hz-crumb">{pageTitle}</div>}
                <h1 className="hz-page-title">{title}</h1>
            </div>
        </div>
    );
};

export default BreadCrumb;
